/**
 * Shared constants across KnitKnot frontend apps.
 *
 * Import these constants to avoid hardcoding values and ensure consistency
 * between console and hosted applications.
 */

// Authentication
export const AUTH_COOKIE_NAME = 'knitknot_token';
export const KNITKNOT_EMAIL_DOMAIN = 'knitknot.ai';
export const ADMIN_ACCOUNT_DOMAIN_PARAM = 'admin_account_domain';

/** UI-level staff affordance gate. The internal API still enforces superadmin
 * access server-side; this only decides whether a customer-console link is
 * visible. */
export function isKnitKnotEmail(email: string | null | undefined): boolean {
  return email?.trim().toLowerCase().endsWith(`@${KNITKNOT_EMAIL_DOMAIN}`) ?? false;
}

// Cache settings
export const DEFAULT_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
